import React from 'react'

import { Button, Heading, Link, Stack, Text } from '@doist/marketist'

import { GetStaticPropsContext } from 'next/types'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import css from './_error.module.css'

function Error() {
    return (
        <div className={css.errorPage}>
            <img src={require('public/assets/images/404.png')} />

            <Stack gap="24">
                <Heading level="3" size="major-sm">
                    Hmmm, that page doesn&apos;t exist.
                </Heading>

                <Text size="body-sm">
                    Head over to our <Link href="/home">homepage</Link> that definitely does exist,
                    or visit our <Link href="/help">help center</Link> for any questions.{' '}
                </Text>

                <Button href={`/a/`} size="large">
                    Back to Twist
                </Button>
            </Stack>
            <Link href="/help" className="mbs-16">
                Visit our Help Center
            </Link>
        </div>
    )
}

export async function getStaticProps({ locale = 'en' }: GetStaticPropsContext) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common', 'error'])),
        },
    }
}

export default Error
